import { object, mixed, string, array, number } from "yup";

export const invoiceValidation = object({
  invoice_number: string().nullable().required("Invoice number is required"),
  currency: string().nullable().required("Currency is required"),
  invoice_date: mixed().required("Invoice Date is required"),
  customer_id: string().required("Customer is required"),
  invoice_items: array().of(
    object({
      billing_period_enabled: mixed().notRequired(),
      billing_period_end_date: mixed().when("billing_period_enabled", {
        is: true,
        then: mixed().required("Billing start date is required"),
        otherwise: mixed().notRequired(),
      }),
      billing_period_start_date: mixed().when("billing_period_enabled", {
        is: true,
        then: mixed().required("Billing end date is required"),
        otherwise: mixed().notRequired(),
      }),
    }).test(
      "billing-dates-complete",
      "Billing start date and end date must be provided if billing date is enabled",
      (value: {
        billing_period_enabled: boolean;
        billing_period_end_date: string;
        billing_period_start_date: string;
      }) => {
        if (value.billing_period_enabled) {
          return (
            Boolean(value.billing_period_end_date) &&
            Boolean(value.billing_period_start_date)
          );
        }
        return true;
      }
    )
  ),
});

export const InvoiceItemValidation = object({
  description: string().required("Description is required"),
  product_data_id: mixed().when("description", {
    is: (description: string) => !description || description.trim() === "",
    then: mixed().required("Item is required"),
    otherwise: mixed().notRequired(),
  }),
  category_id: mixed().when("is_public_bill_item", {
    is: true,
    then: mixed().notRequired(),
    otherwise: mixed().required("Category is required"),
  }),
  quantity: number()
    .required("Quantity is required")
    .min(1, "Quantity must be positive"),
  rate: number().required("Rate is required"),
  billing_period_enabled: mixed().notRequired(),
  billing_period_start_date: mixed().when("billing_period_enabled", {
    is: true,
    then: mixed().required("Billing start date is required"),
    otherwise: mixed().notRequired(),
  }),
  billing_period_end_date: mixed().when("billing_period_enabled", {
    is: true,
    then: mixed().required("Billing end date is required"),
    otherwise: mixed().notRequired(),
  }),
});
